import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberOnlyDirective } from '../directives/number-only.directive';
import { InitialsPipe } from '../pipes/initials.pipe';


const modules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  NumberOnlyDirective,
  InitialsPipe,
];

@NgModule({
  imports: [...modules],
  exports: [...modules]
})
export class SharedModule {}
